"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const react_1 = __importDefault(require("react"));
const react_icons_1 = require("@grandlinex/react-icons");
const util_1 = require("../../util");
const Tooltip_1 = __importDefault(require("../tooltip/Tooltip"));
const IconButton = function (props) {
    const { onClick, disabled, icon, children, color, className, toolTip } = props;
    return (react_1.default.createElement(Tooltip_1.default, { text: toolTip?.text, width: toolTip?.width, className: toolTip?.className, position: toolTip?.position },
        react_1.default.createElement("button", { className: (0, util_1.cnx)('glx-icon-button', className, [
                !!color,
                `glx-icon-button--${color}`,
                'glx-icon-button--default',
            ]), type: "button", onClick: onClick, disabled: disabled },
            react_1.default.createElement("span", null,
                icon ? (0, react_icons_1.getIcon)(icon)({}) : null,
                children))));
};
exports.IconButton = IconButton;
IconButton.defaultProps = {
    color: undefined,
    className: undefined,
    disabled: undefined,
    toolTip: undefined,
    children: undefined,
    icon: undefined,
};
